const customAgGridFilter = {
  textFilterParams: {
    filterOptions: ['contains', 'notContains'],
    textFormatter: (r) => {
      if (r == null) return null
      return r
        .toLowerCase()
        .replace(/[àáâãäå]/g, 'a')
        .replace(/æ/g, 'ae')
        .replace(/ç/g, 'c')
        .replace(/[èéêë]/g, 'e')
        .replace(/[ìíîï]/g, 'i')
        .replace(/ñ/g, 'n')
        .replace(/[òóôõö]/g, 'o')
        .replace(/œ/g, 'oe')
        .replace(/[ùúûü]/g, 'u')
        .replace(/[ýÿ]/g, 'y')
    },
    debounceMs: 200,
    buttons: ['reset', 'apply'],
    suppressAndOrCondition: true
  },
  numberFilterParams: {
    filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual', 'inRange'],
    debounceMs: 200,
    buttons: ['reset', 'apply'],
    suppressAndOrCondition: true
  },
  dateFilterParams: {
    filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual', 'inRange'],
    debounceMs: 200,
    buttons: ['reset', 'apply'],
    suppressAndOrCondition: true
  },
  booleanFilterParams: {
    filterOptions: ['equals', 'notEqual'],
    textFormatter: (value) => {
      return Boolean(value)
    },
    debounceMs: 200,
    buttons: ['reset', 'apply'],
    suppressAndOrCondition: true
  }
}

export default customAgGridFilter



// WEBPACK FOOTER //
// ./src/constants/custom-filter-params.js